"use client";

import {
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
  ToastViewport
} from "./toast";

export function Toaster({ toasts = [] }: { toasts?: any[] }) {
  return (
    <>
      {toasts.map(({ id, title, description, action, ...props }) => (
        <Toast key={id} {...props}>
          <div className="grid gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
          </div>
          {action}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </>
  );
}
